
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "fa1398a7e4f7b4dd2382ebd796d3e60dfa2c48ff",
  "nuxt": {
    "buildId": "d1a9309e-d831-4965-9081-aff11ae5078a"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
